import client from '../httpClient';

// sendmail018
const getSendLibraryMails = (params) => {
  return client.get('/send-mails/library/counts', { params });
};

export default getSendLibraryMails;
